export default {
    description: "Descrizione",
    orderingNote: "Nota per l'ordine"
}